import { htmlToElement } from "@modules/bookmarks/html-parser"
import "@modules/_components/HTMLDynamicListElement"
import type { DynamicListItem, HTMLDynamicListElement } from "@modules/_components/HTMLDynamicListElement"

export type BookmarkEntryData = DynamicListItem & {
    name: string
    locality: string
    thumbnail: string
    url: string
}

export const generateBookmarksDropdownList = (): HTMLDynamicListElement<BookmarkEntryData> =>
    htmlToElement<HTMLDynamicListElement<BookmarkEntryData>>(`
    <dynamic-list class="bookmark-dropdown" list-container-type="div" container-class="bookmark-dropdown-entries-list">
        <template>
            <a href="{url}" target="_self" class="link" title="">
                <span class="thumbnail"><img src="{thumbnail}" alt="{name}" class="img-responsive"></span>
                <span class="text">
                    <span class="text-bold cut-text">{name}</span>
                    <span class="cut-text">{locality}</span>
                </span>
            </a>
        </template>
        <header>
            <h2 class="dropdown-header info-heading">Merkzettel</h2>
            <div class="loader"></div>
        </header>
        <footer>
            <div id="bookmarks-with-entries-footer" class="bookmarks-footer-counts" hidden>
                <p id="bookmarks-offline-count-wrapper" hidden>+ <span id="bookmarks-offline-count">0 Einträge</span> offline</p>
                <p><a class="blue-link" href="/merkzettel">Alle <span id="bookmarks-online-count">0 Einträge</span> ansehen &gt;</a></p>
            </div>
            <div id="bookmarks-no-entries-footer" hidden>
                <strong>Du hast zurzeit keine Einträge in deinem Merkzettel.</strong>
                <hr>
                Nutze einfach die Schaltfläche
                <div class="merkzettel-button">
                    <svg viewBox="0 0 20 20">
                        <path d="M3.437 18.885l2.028-6.354-5.248-3.709c-0.231-0.162-0.286-0.481-0.124-0.711 0.099-0.141 0.257-0.216 0.418-0.216v-0.002h6.581l2.413-7.125c0.090-0.267 0.38-0.41 0.647-0.319 0.155 0.053 0.268 0.174 0.318 0.318l0.002-0.001 2.458 7.126h6.56c0.282 0 0.511 0.229 0.511 0.511 0 0.186-0.1 0.349-0.248 0.438l-5.194 3.686 2.020 6.383c0.085 0.269-0.065 0.556-0.334 0.641-0.167 0.053-0.342 0.016-0.471-0.085l-5.784-3.68-5.802 3.708c-0.237 0.151-0.552 0.081-0.703-0.156-0.090-0.141-0.103-0.309-0.047-0.455zM6.549 12.483l-1.722 5.395 4.888-3.123c0.162-0.102 0.375-0.11 0.547-0l4.917 3.129-1.709-5.4c-0.065-0.205 0.007-0.438 0.192-0.569l4.224-2.998h-5.296c-0.222 0.012-0.434-0.125-0.509-0.346l-2.089-6.059-2.045 6.035c-0.062 0.213-0.257 0.369-0.491 0.369h-5.338l4.238 2.997c0.177 0.124 0.262 0.353 0.193 0.569z"></path>
                    </svg>
                    <span class="button-label">Anzeige merken</span>
                </div>
                bei deinen favorisierten Anzeigen.
            </div>
        </footer>
    </dynamic-list>
`)
